var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsExternalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#338dc7;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-432 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.8,10.6l2.11-2.116L26.8,11.352a2.024,2.024,0,0,1-2.1,1.943Zm-1.36-3.392L12.563,18.141A1.013,1.013,0,0,0,14,19.569L24.874,8.637s1.831-1.843,1.831-1.843a1.013,1.013,0,0,0-.763-1.726l-5.229.243a1.96,1.96,0,0,0-1.406.647,2,2,0,0,0-.527,1.456S23.437,7.207,23.438,7.209Zm-2.726,7.836h-.02v9.486H7.526V11.375h9.749v-.02l2-2.007-2,0s-9.976,0-9.976,0a1.8,1.8,0,0,0-1.8,1.8V24.76a1.8,1.8,0,0,0,1.8,1.8H20.92a1.8,1.8,0,0,0,1.8-1.8V15.045s0-2,0-2Z",
    transform: "translate(427.5 461.933)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(432 465)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsExternalLink);
export default __webpack_public_path__ + "static/media/icons-external-link.6eafdc73.svg";
export { ForwardRef as ReactComponent };